module.exports = __webpack_public_path__ + "static/img/3_2_5_1.e42f6699.jpg";